import CompanyImage from './assets/images/turinge_larsson_logotype.png';
import './App.css';

function App() {

  const tireServices = ['Däckbyte', 'Däckhotell', 'Försäljning', 'Omläggning', 'Balansering', 'Lagning'];

  const gardeningProducts = [
    { name: 'Planteringsjord', amount: '80L' },
    { name: 'Barkmull', amount: '50L' },
    { name: 'Täckbark', amount: '50L' },
    { name: 'Rosjord', amount: '50L' },
    { name: 'Rhododendronjord', amount: '50L' },
    { name: 'Kogödsel', amount: '50L' },
    { name: 'Hönsgödsel', amount: '15KG' },
    { name: 'Gräsgödsel', amount: '10KG' },
    { name: 'Dressjord', amount: '50L' },
    { name: 'Pelargonjord', amount: '20L' },
    { name: 'Blomjord', amount: '20L' },
    { name: 'Urnjord', amount: '50L' },
    { name: 'Naturtorv', amount: '80L' },
    { name: 'Torvfri jord', amount: '40L' },
    { name: 'Grönsaksjord', amount: '40L' },
  ];

  return (
    <div className="App">
      <header className="top-section">
        <div className="content hero">
          <div className="company-image">
            <img alt="Larsson i Turinge Logotype" src={CompanyImage} />
          </div>

          <h1 className="sr-only">Larsson i Turinge</h1>

          <p className="hero-subtitle">
            Däck, trädgårdsprodukter och mycket mer.
          </p>

          <div className="hero-cta">
            <a className="cta-button" href="tel:+46855240340" aria-label="Ring Larsson i Turinge">
              Ring: 08-552 403 40
            </a>
            <a className="cta-button secondary" href="mailto:mattiaslarsson68@hotmail.com">
              Skicka e‑post
            </a>
          </div>
        </div>

        <section className="grid-section-3 basic-info-section" aria-label="Grundinformation">
          <article className="basic-info-column">
            <div className="basic-info-wrapper card">
              <header className="basic-info-title">
                <h2>Öppettider</h2>
                  <p className="muted">Aktuella öppettider hittar du på vår {' '}
                    <a
                      href="https://www.facebook.com/profile.php?id=100068434028249"
                      rel="noreferrer"
                      target="_blank"
                  >
                    Facebook
                  </a>
                    .
                </p>
              </header>

              <div className="basic-info-content">
                <p className="note">
                  <i>(Däckverkstaden stänger alltid en halvtimme innan)</i>
                </p>
              </div>
            </div>
          </article>

          <article className="basic-info-column">
            <div className="basic-info-wrapper card">
              <header className="basic-info-title">
                <h2>Kontakta oss</h2>
              </header>

              <div className="basic-info-content">
                <dl className="contact-list">
                  <div className="contact-row">
                    <dt>Telefon</dt>
                    <dd>
                      <a href="tel:+46855240340">08-552 403 40</a>
                    </dd>
                  </div>

                  <div className="contact-row">
                    <dt>Adress</dt>
                    <dd>
                      Gamla Strängnäsvägen 342
                      <br />
                      15591 Nykvarn
                    </dd>
                  </div>

                  <div className="contact-row">
                    <dt>E-post</dt>
                    <dd><a href="mailto:mattiaslarsson68@hotmail.com">Skicka e‑post</a></dd>
                  </div>
                </dl>


                <div className="stack">

                  <a
                    className="cta-link"
                    href="https://www.facebook.com/profile.php?id=100068434028249"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Följ oss på Facebook
                  </a>
                </div>
              </div>
            </div>
          </article>
        </section>
      </header>

      <div className="separator" />

      <main className="grid-section-3 sales-section" aria-label="Sortiment och tjänster">
        <section className="sales-tires card" aria-label="Däck">
          <h2 className="sales-title">Däck</h2>
          <div className="sales-content">
            <ul className="clean-list">
              {tireServices.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="sales-gardening card" aria-label="Trädgårdsprodukter">
          <h2 className="sales-title">Trädgårdsprodukter</h2>
          <div className="sales-content">
            <p className="muted">
              Jord från{' '}
              <a href="https://www.sodraarhultstorv.se/" rel="noreferrer" target="_blank">
                Södra Århults torv
              </a>
              .
            </p>

            <p className="highlight">Kan även levereras.</p>

            <ul className="clean-list">
              {gardeningProducts.map(({ name, amount }) => (
                <li key={`${name}-${amount}`}>
                  <span className="list-row">
                    {name} <span className="list-amount-content">- {amount}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="sales-misc card" aria-label="Övrigt">
          <h2 className="sales-title">Övrigt</h2>
          <div className="sales-content">
            <ul className="clean-list">
              <li>
                <span className="list-row">
                  Vedförsäljning <span className="list-amount-content">- även leverans</span>
                </span>
              </li>
              <li>Biltillbehör</li>
              <li>Mindre kiosk</li>
            </ul>
          </div>
        </section>
      </main>

      <div className="separator" />

      <footer className="footer" aria-label="Sidfot">
        <div className="footer-inner">
          <div className="stack">
            <strong>Larsson i Turinge AB</strong>
            <a href="tel:+46855240340">08-552 403 40</a>
            <span>
              Gamla Strängnäsvägen 342
              <br />
              15591 Nykvarn
            </span>
          </div>

          <a
            className="cta-link"
            href="https://www.facebook.com/profile.php?id=100068434028249"
            rel="noreferrer"
            target="_blank"
          >
            Följ oss på Facebook
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
